{
  "title": "Жеке профиль",
  "info": "Жеке мәліметтер",
  "idCopy": "ID көшіру",
  "copied": "ID көшірілді",
  "copyFailed": "ID көшірілмеді",
  "name": "Аты",
  "surname": "Тегі",
  "birth": "Туған күні",
  "gender": "Жынысы",
  "chooseGender": "Жынысты таңдаңыз",
  "male": "Ер",
  "female": "Әйел",
  "save": "Сақтау",
  "saved": "Ақпарат сақталды",
  "missing": "Барлық жеке деректерді толтырыңыз.",
  "failed": "Сақтау мүмкін болмады.",
  "alreadySaved": "Жеке деректер расталды және құлыпталды.",
  "confirmTitle": "Растаңыз",
  "confirmText": "Деректердің дұрыстығын растаңыз. Кейін өзгерту үшін әкімші рұқсаты қажет.",
  "verify": "Растау",
  "back": "Артқа",
  "contacts": "Байланыс деректері",
  "linked": "Қосылған",
  "notLinked": "Қосылмаған",
  "unverified": "Расталмаған",
  "manage": "Басқару",
  "telegram": "Telegram",
  "unavailable": "Жоқ",
  "phone": "Телефон",
  "email": "Электрондық пошта",
  "change": "Өзгерту сұрауы",
  "pending": "Сұрау қаралуда.",
  "requestTitle": "Деректерді өзгерту",
  "changeHelp": "Әкімші мақұлдауы керек.",
  "reason": "Өзгерту себебі",
  "submit": "Сұрауды жіберу",
  "noChanges": "Өзгеріс жоқ.",
  "changeFailed": "Сұрау жіберілмеді.",
  "changeSent": "Сұрау әкімшіге жіберілді.",
  "support": "Қолдау қызметі",
  "age": "Туған күнді дұрыс енгізіңіз.",
  "loggingOut": "Шығу...",
  "logout": "Аккаунттан шығу"
}
